module.exports = __webpack_public_path__ + "img/12.01465e82.png";